import { actions } from 'react/api/actions/tabs';

Monet.UI = Monet.UI || {};

Monet.UI.Help = function (help, title) {

    this.title = title;
    this.help = help || "Home";
    this.content = document.createElement("div");
    this.content.setAttribute("class", "MonetUIHelp");
    this.url;
    this.link;
    this.hasCreated;
    this.noHelpTitle = false;

    this.key = `help_${this.help}`;

    const generateUrl = () => {
        const helpUrl = 'https://greenmile.help.descartesservices.com';

        /**
         * TODO: Generate the url with the help link of accordion to the page related, and
         * change the url in each places that call this module.
         *
         * Like this:
         * this.url = helpUrl + "/" + this.help;
         */

        this.url = helpUrl;
    };

    const domMainContainer = () => document.querySelector("#" + this.key);

    const insertContent = () => {
        const container = domMainContainer();
        const content = document.createElement("iframe");

        if (container) {
          container.appendChild(content);
        }

        content.setAttribute("src", this.url);
        content
          .setAttribute(
            "sandbox",
            "allow-scripts allow-forms allow-same-origin allow-downloads allow-modals allow-presentation"
          );
        content.style.border = 0;
        content.style.width = "100%";
        content.style.height = "100%";
        content.style.position = "absolute";

        content.onload = () => {
            const loaderDiv = document.querySelector("#" + this.key + " .loader-help-content");
            loaderDiv.style.display = "none";
            this.hasCreated = true;
        };
    };

    this.logIn = function (afterLogin) {
        if (!afterLogin) {
            window.open(this.url, '_blank', 'noopener,noreferrer');

            return;
        }

        const helpTitle = this.noHelpTitle ? this.title : `Help ${this.title}`;
        const actionType = afterLogin ? actions.openHelpAfterLogin : actions.openHelp;

        GreenmileReduxStore.dispatch({
            type: actionType,
            payload: {
                key: this.key,
                title: helpTitle,
            },
            settings: {
                didMount: () => requestUrl()
            }
        });
    };

    const showLoader = () => {
        const loaderDiv = document.createElement("div");
        loaderDiv.className = "loader-help-content";
        domMainContainer().appendChild(loaderDiv);
    };

    const requestUrl = () => {
        showLoader();
        insertContent();
    };

    this.renderLink = function () {
        const translatedTitle = Monet.I18n.getResourcesByKey("Greenmile.Grid.Button.helpPage");

        this.link = document.createElement("a");
        this.link.setAttribute("href", this.url);
        this.link.setAttribute("class", "MonetUIHelpLink");
        this.link.setAttribute("title", translatedTitle);
        this.link.addEventListener("click", (event) => {
            event.preventDefault();
            window.open(this.link, "_blank", 'noopener,noreferrer');
        });
        return this.link;
    };

    generateUrl();
    this.render = function () {
        this.content.appendChild(this.renderLink());

        return this.content;
    };
};
